
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces'

@Component
export default class RemoveServerDialog extends Vue {
  @Prop() private readonly server!: ServerInterface
  @Prop() private readonly onDelete!: CallableFunction

  private visible: boolean = true

  get message(): string {
    return `Are you sure you want to remove server ${this.server.hostname}?`
  }

  private destroyComponent(): void {
    this.$emit('close')
  }

  private async deleteServer(): Promise<void> {
    await this.onDelete(this.server)
    this.destroyComponent()
  }
}
